// extracted by mini-css-extract-plugin
module.exports = {"container":"VolumeSlider__container__2YKkm","iconBtn":"VolumeSlider__iconBtn__3Z0dt","slider":"VolumeSlider__slider__1FWI3"};